/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CommunityMembers } from '../../models/community-members';

export interface CommunityControllerGetMembers$Params {
  id: number;
  query?: string;
  limit: number;
  skip: number;
}

export function communityControllerGetMembers(http: HttpClient, rootUrl: string, params: CommunityControllerGetMembers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityMembers;
}>> {
  const rb = new RequestBuilder(rootUrl, communityControllerGetMembers.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('query', params.query, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CommunityMembers;
      }>;
    })
  );
}

communityControllerGetMembers.PATH = '/community/{id}/members';
